import { ENV } from '../config/constant';
import { axios } from '../config/axios';
import { sliceParamAarry } from '../config/utils';
const { VUE_APP_API_HOST_ZLZ: HOST } = ENV;

/**
 *创建建筑
 * @param {string}  protectionLevelEnum 保护级别
 * @param {string}  relicAge 建筑年代
 * @param {string}  relicDistrictEnum 所属区域
 * @param {string}  relicFromUserId 创建建筑用户id
 * @param {string}  relicName 建筑名称
 * @param {string}  relicTypeEnum 建筑类别
 */
export function createRelic({
  protectionLevelEnum,
  relicAge,
  relicDistrictEnum,
  relicFromUserId,
  relicName,
  relicTypeEnum
} = {}) {
  return axios.post(
    `${HOST}/relic`,
    {
      protectionLevelEnum,
      relicAge,
      relicDistrictEnum,
      relicFromUserId,
      relicName,
      relicTypeEnum
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 *删除建筑
 * @param {array} deleteRelicList
 */
export function deleteRelic(deleteRelicList) {
  const relicList = sliceParamAarry(deleteRelicList);
  const promises = [];
  relicList.map(item => {
    const params = item
      .map(({ relicAutoIncrementId: id }) => `relicAutoIncrementId=${id}`)
      .join('&');
    promises.push(axios.delete(`${HOST}/relic?${params}`));
  });

  return Promise.allSettled(promises);
}

/**
 * 查看建筑详情
 * @param {number} id 建筑自增id
 */
export function getRelicDetail(id) {
  return axios.get(`${HOST}/relic/${id}`);
}

/**
 * 通过建筑自增id更新基本信息
 * @param {Object} params
 * @param {number} params.coordinateX 经度坐标
 * @param {number} params.coordinateY 维度坐标
 */
export function updateRelicBasicDetail(params) {
  return axios.put(`${HOST}/relic/info/basic`, params, {
    headers: { 'Content-Type': 'application/json' }
  });
}

/**
 * 搜索建筑列表
 * @param {string} frameContent 搜索框内容
 * @param {string} inspectStatusEnum 巡查状态
 * @param {number} page 页数
 * @param {number} pageSize 条数
 * @param {string} protectionLevelEnum 保护等级
 * @param {string} relicDistrictEnum 所属区域
 * @param {string} relicFromUserIdAsc 排序
 * @param {string} relicTypeEnum 建筑类别
 */
export function searchRelic({
  frameContent = '',
  inspectStatusEnum = '',
  page = 1,
  pageSize = 20,
  protectionLevelEnum = '',
  relicDistrictEnum = '',
  relicFromUserIdAsc = false,
  relicTypeEnum = ''
} = {}) {
  return axios.get(`${HOST}/relic/table/private`, {
    params: {
      frameContent,
      inspectStatusEnum,
      page,
      pageSize,
      protectionLevelEnum,
      relicDistrictEnum,
      relicFromUserIdAsc,
      relicTypeEnum
    }
  });
}

/**
 * 通过建筑自增id更新规划信息
 * @param {Object} params
 * @param {string} params.controlArea 建控面积
 * @param {string} params.controlRequirement 建控要求
 * @param {string} params.protectArea 保护面积
 * @param {string} params.protectRequirement 保护要求
 * @param {number} params.relicAutoIncrementId 建筑自增id
 * @param {number} params.controlCgcs 建控cgcs坐标
 * @param {number} params.controlCoordinate 高德坐标字符串
 * @param {number} params.protectCgcs 保护cgcs坐标
 * @param {number} params.protectCoordinate 高德坐标字符串
 */
export function updateRelicPlan(params) {
  return axios.put(`${HOST}/relic/info/planning`, params, {
    headers: { 'Content-Type': 'application/json' }
  });
}

/**
 * 获取所有建筑的坐标，保护范围，建控范围
 */
export function getGisCoordinate() {
  return axios.get(`${HOST}/relic/info/gis/all`);
}

/**
 *得到所有自定义属性
 */
export function getCustomproperty() {
  return axios.get(`${HOST}/customproperty`);
}

/**
 * 新增自定义属性
 */
export function addCustomproperty() {
  return axios.post(`${HOST}/customproperty`);
}

/**
 * 上传kml文件
 */
export function uploadKML() {
  return axios.put(`${HOST}/relic/info/kml`);
}

/**
 * 分页查看图片
 */
export function getRelicPhoto({
  page = 1,
  pageSize = 7,
  relicAutoIncrementId,
  doPaging = true
} = {}) {
  return axios.get(`${HOST}/relic/photo/list`, {
    params: {
      doPaging,
      page,
      pageSize,
      relicAutoIncrementId
    }
  });
}

/**
 * 批量新建图片
 * @param {Array} relicPhotoInsertQueryList 新建图片数组列表
 * 数组参数
 * "description": "string",
    "filmId": "string",
    "photoId": "string",
    "photoName": "string",
    "photographer": "string",
    "relicAutoIncrementId": 0,
    "shootDirection": "string",
    "shootTime": "string",
    "showInMap": true,
    "url": "string"
    thumb
 */
export function addRelicPhoto(relicAutoIncrementId, relicPhotoInsertQueryList) {
  return axios.post(
    `${HOST}/relic/photos`,
    { relicAutoIncrementId, relicPhotoInsertQueryList },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 * 删除单张建筑照片
 */
export function deleteRelicPhoto(relicPhotoAutoIncrementId) {
  return axios.delete(`${HOST}/relic/photo`, {
    params: {
      relicPhotoAutoIncrementId
    }
  });
}

/**
 *获得建筑照片信息
 * @param {String} id 建筑照片自增id
 */
export function getPhotoInformation(id) {
  return axios.get(`${HOST}/relic/photo/${id}`);
}
/**
 *更新封面
 */
export function updateCoverRelicImg({ coverUrl, relicAutoIncrementId }) {
  return axios.put(
    `${HOST}/relic/cover`,
    {
      coverUrl,
      relicAutoIncrementId
    },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 * 更新照片信息
 */
export function updateRelicPhoto({
  description,
  filmId,
  photoId,
  photoName,
  photographer,
  relicAutoIncrementId,
  relicPhotoAutoIncrementId,
  shootDirection,
  shootTime
} = {}) {
  return axios.put(`${HOST}/relic/photo`, {
    description,
    filmId,
    photoId,
    photoName,
    photographer,
    relicAutoIncrementId,
    relicPhotoAutoIncrementId,
    shootDirection,
    shootTime
  });
}

/**
 * 更新单张照片是否在地图上显示
 */
export function updateRelicPhotoInMap({
  relicPhotoAutoIncrementId,
  showInMap
}) {
  return axios.put(`${HOST}/relic/photo/shown`, {
    relicPhotoAutoIncrementId,
    showInMap
  });
}

//图纸部分

/**
 * 批量新建图纸
 * @param {array} relicDrawingInsertQueryList 保存图纸数组
 * [
  {
    "createTime": "string",
    "creator": "string",
    "drawingId": "string",
    "drawingName": "string",
    "relicAutoIncrementId": 0,
    "relicDrawingAutoIncrementId": 0,
    "scale": "string",
    "showInMap": true,
    "url": "string"
  }
]
 */
export function addRelicDrawing(
  relicAutoIncrementId,
  relicDrawingInsertQueryList
) {
  return axios.post(
    `${HOST}/relic/drawings`,
    { relicAutoIncrementId, relicDrawingInsertQueryList },
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );
}

/**
 * 分页查看图纸列表
 */
export function getRelicDrawing({
  page = 1,
  pageSize = 7,
  relicAutoIncrementId,
  doPaging = true
}) {
  return axios.get(`${HOST}/relic/drawing/list`, {
    params: {
      doPaging,
      page,
      pageSize,
      relicAutoIncrementId
    }
  });
}

/**
 * 更新单张图纸的信息
 */
export function updateRelicDrawing({
  createTime,
  creator,
  drawingId,
  drawingName,
  relicAutoIncrementId,
  relicDrawingAutoIncrementId,
  scale
}) {
  return axios.put(`${HOST}/relic/drawing`, {
    createTime,
    creator,
    drawingId,
    drawingName,
    relicAutoIncrementId,
    relicDrawingAutoIncrementId,
    scale
  });
}

/**
 * 删除单张图纸
 */
export function deleteRelicDrawing(relicDrawingAutoIncrementId) {
  return axios.delete(`${HOST}/relic/drawing`, {
    params: {
      relicDrawingAutoIncrementId
    }
  });
}

/**
 * 更新单张图纸是否在地图上填写
 */
export function updateDrawingInMap({ relicDrawingAutoIncrementId, showInMap }) {
  return axios.put(`${HOST}/relic/drawing/shown`, {
    relicDrawingAutoIncrementId,
    showInMap
  });
}

/**
 * 查看自增id对应的图纸信息
 */
export function getDrawingInformation(id) {
  return axios.get(`${HOST}/relic/drawing/${id}`);
}

/**
 * 获取不同类别建筑的信息数量
 */
export function getRelicCountByKind() {
  return axios.get(`${HOST}/reliccount/public`);
}

/**
 * 获得所有建筑在地图上所需要的一个点信息
 */
export function getMapPoints() {
  return axios.get(`${HOST}/relic/mapelements/public`);
}
/**
 * 上传建筑规划文件pdf
 */
export function uploadingRelicPDF({ relicAutoIncrementId, pdfUrl }) {
  return axios.put(
    `${HOST}/relic/${relicAutoIncrementId}/planning?pdfUrl=${pdfUrl}`
  );
}

/**
 * 地图界面查找所有信息
 */
export function searchRelicListInMap({
  frameContent = '',
  inspectStatusEnum,
  page = 1,
  pageSize = 0,
  protectionLevelEnums,
  relicDistrictEnums,
  relicFromUserIdAsc,
  relicTypeEnums
} = {}) {
  return axios.get(
    `${HOST}/relic/table/public?frameContent=${frameContent}&page=${page}&pageSize=${pageSize}&protectionLevelEnums=${protectionLevelEnums}&relicDistrictEnums=${relicDistrictEnums}&relicTypeEnums=${relicTypeEnums}`
  );
}

/**
 * 获取地图详情
 */
export function getMapRelicDetail(relicAutoIncrementId) {
  return axios.get(`${HOST}/relic/info/map/private`, {
    params: { relicAutoIncrementId }
  });
}

/**
 * 游客地图获取地图详情
 */
export function getMapRelicDetailPublic(relicAutoIncrementId) {
  return axios.get(`${HOST}/relic/info/map/public`, {
    params: { relicAutoIncrementId }
  });
}

/**
 * 获取点云照片
 * @param {Object} params
 * @param {Object} params.doPaging 是否分页
 * @param {Object} params.page
 * @param {Object} params.pageSize
 * @param {Object} params.relicAutoIncrementId
 * @returns
 */
export function GetPointCloudPhoto(params) {
  return axios.get(`${HOST}/relic/photo/pointcloud/list`, { params });
}

/**
 *  上传点云照片
 * @param {Array} params 照片数组
 * @returns
 */
export function UpdatePointCloudPhoto(params) {
  return axios.post(`${HOST}/relic/photo/pointcloud`, params, {
    headers: { 'Content-Type': 'application/json' }
  });
}

export function DeletePointCloudImg(id) {
  return axios.delete(`${HOST}/relic/photo/pointcloud?id=${id}`);
}
